import {
    apiConfigs as apiConfigsICS,
    clientRoute,
    EmployeeDTO,
    handleAxiosErrorByResponseStatus,
    PersonDTO,
    RequestDTO as RequestDTOICS,
    RequestFormDTO as RequestFormDTOICS,
    RequestStore as RequestStoreICS,
    TabDTO as TabDTOICS,
} from '@platform/ics-front-core';
import { action } from 'mobx';
import { injectable } from 'react-magnetic-di';
import apiConfigs from '../../apiConfigs';
import { SpecialExecutorType } from '../../types/campaignRequest';
import { CampaignRequestPfDTO } from '../models/campaign-request-pf/CampaignRequestPfModel';

export type RequestDTO = RequestDTOICS & {
    customTabs: TabDTO[];
    specialExecutors: Partial<
        Record<
            SpecialExecutorType,
            {
                userId: string;
                person: PersonDTO;
            }
        >
    >;
};

export type TabDTO = TabDTOICS & {
    identifier: string;
};

export type RequestFormDTO = RequestFormDTOICS & {
    identifier: string;
};

export class RequestStore extends RequestStoreICS {
    @action.bound
    getRequestDTO(requestId: string): Promise<RequestDTO> {
        return this.api
            .client(apiConfigsICS.getRequest(requestId))
            .then((r) => r.data)
            .catch(
                handleAxiosErrorByResponseStatus({
                    403: () => this.history.replace(clientRoute.notAllowed),
                    404: () => this.history.replace(clientRoute.notFound),
                }),
            );
    }

    @action.bound
    generatePrintForm(formId: string, templateId: string): Promise<CampaignRequestPfDTO> {
        return this.api.client(apiConfigs.generatePrintForm(formId, templateId)).then((r) => r.data);
    }

    @action.bound
    loadRequestCustomForm(customFormId: string): Promise<RequestFormDTO> {
        return this.api.client(apiConfigsICS.loadRequestForm(customFormId)).then((r) => r.data);
    }

    @action.bound
    getEmployeesList(): Promise<EmployeeDTO[]> {
        return this.api.client(apiConfigs.getAllActiveEmployees()).then((r) => r.data);
    }

    @action.bound
    getSpecialExecutorUsers(requestId: string): Promise<EmployeeDTO[]> {
        return this.api.client(apiConfigs.getSpecialExecutorUsers(requestId)).then((r) => r.data);
    }

    @action.bound
    editSpecialExecutorSettings(requestId: string, userId: string, executorType: SpecialExecutorType): Promise<void> {
        return this.api
            .client(apiConfigs.editSpecialExecutorSettings(requestId, userId, executorType))
            .then((r) => r.data);
    }

    @action.bound
    getSpecialExecutorSettings(requestId: string, executorType: SpecialExecutorType): Promise<EmployeeDTO> {
        return this.api.client(apiConfigs.getSpecialExecutorSettings(requestId, executorType)).then((r) => r.data);
    }
}

export const RequestStoreDI = injectable(RequestStoreICS, RequestStore);
